// 発言テキストの整形。サーバー側の App\Traits\CleanUpSpeechTextTrait::cleanUpSpeechText() と
// 同じ内容・同じ適用順に揃えてある。表示される発言と解析（ホットワード・ポジネガ分析）へ渡す
// 発言を一致させるため、片方だけを変更しないこと。
//
// JavaScript の \s は全角スペース（U+3000）を含むため、deleteStr1 は会議録APIの
// 「○発言者名 + 全角スペース + 本文」形式を除去できる。PCRE の \s は全角スペースを
// 含まないため、PHP 側は同じ正規表現では動作せず全角スペースを明示している。
const deleteStr1 = /^○.+?\s/;
const deleteStr2 = "─";
const deleteStr3 = /\s.+\s$/;
const deleteStr4 = "―";
const deleteStr5 = "◇";

export const unnecessaryTextDel = (text: string) => {
  return text
    .replace(deleteStr1, "")
    .replaceAll(deleteStr2, "")
    .replace(deleteStr3, "")
    .replaceAll(deleteStr4, "")
    .replaceAll(deleteStr5, "");
};

export const enTenThousandRounding = (value?: number) => {
  const calcValue = tenThousandRounding(value);
  return calcValue === 0 ? "-" : `￥${calcValue}万`;
};

export const tenThousandRounding = (value?: number) => {
  const calcValue = value || 0;
  const tenThousandValue = calcValue / 10000;
  return Math.round(tenThousandValue);
};

export const formatLatestSpeechDate = (value: string) => {
  return value === "2000-01-01" ? "-" : value;
};

// 生成AIが返す文章の整形。「**見出し**:」のように見出しと本文が同じ行に続く形で
// 返ってくることがあり、そのままでは markdown が段落として解釈しないため改行を補う。
// 議員ページと政党ページのAI分析欄で共通して使う。
export const aiGeneratedTextFormat = (value: string) => {
  return value.replaceAll(":**", "** \n\n").replaceAll("**: ", "** \n\n");
};

// 国会 月別まとめの回のタイトル（例: 2026-10 → 2026年10月の国会まとめ）。
// 確定版以外（月次の速報）には末尾に「（速報）」を付ける。週次の最新は「最新の国会まとめ（速報）」とする。
// サーバー側の App\Http\Controllers\Page\DietTrendReportController::title() と同じ組み立てにする。
// BasePage がパンくずの末尾をページタイトルに使うため、食い違うと描画後にタイトルが入れ替わる。
export const dietTrendReportTitle = (
  yearMonth: string,
  reportType?: string,
) => {
  if (reportType === "latest") {
    return "最新の国会まとめ（速報）";
  }
  const [year, month] = yearMonth.split("-");
  const suffix = reportType && reportType !== "final" ? "（速報）" : "";
  return `${year}年${Number(month)}月の国会まとめ${suffix}`;
};
